import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BtnLight from "../../../../../common/element/Buttons/btnLight";
import BtnPrimary from "../../../../../common/element/Buttons/btnPrimary";
import Upload from "../../../../../common/element/Upload";
import Dialog from "../../../../../common/element/Dialog";
import Validations from "../../../../../common/404/Validations";
import useUnauthorizedHandler from "../../../../../common/snippet/useUnauthorizedHandler";
import { UpdateWorkerNote } from "../../../../../actions/admin-worker/UpdateWorkerNote";
import ThreeDotLoader from "../../../../../common/element/ButtonLoader/ThreeDotLoader";

const EditNote = (props) => {
  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const { workerRedirectSpecificData } = useSelector((state) => state);
  
  const [existingFiles, setExistingFiles] = useState([]);
  const [removedAttachments, setRemovedAttachments] = useState([]);
  const [attachment, setAttachment] = useState({ files: [] });
  const [dialogAddOpen, setDialogAddOpen] = useState(false);
  
  const [noteData, setNotData] = useState({
    note_heading: '',
    note: '',
  });
  
  const [noteError, setNoteError] = useState({
    note_heading: '',
    note: '',
    note_attach: ''
  });

  useEffect(() => {
    if (props.noteSpecific) {
      setNotData({
        note_heading: props.noteSpecific.note_heading || '',
        note: props.noteSpecific.note || '',
      });

      let files = [];
      if (props.noteSpecific.attachment && props.noteSpecific.attachment.length > 0) {
        props.noteSpecific.attachment.forEach((data) => {
          const file = data.note_attachment;
          const file_id = data.note_attachment_id;
          const parts = data.note_attachment.split("-");
          let FileName = file;
          if (parts.length >= 3) {
            FileName = parts[parts.length - 1];
            FileName = FileName.replace(/%/g, ' ');
          }
          files.push({
            name: FileName,
            file: file,
            id: file_id
          });
        });
      }
      setExistingFiles(files);
      setRemovedAttachments([]);
    }
  }, [props.noteSpecific]);

  const onAddDialogClose = () => {
    setDialogAddOpen(false);
    props.onDiaCloseBtn();
    props?.GetSpecificOrgNotes();
  };

  const clearFormErrors = () => {
    setNoteError({
      note_heading: '',
      note: '',
      note_attach: ''
    });
  };

  const inputChangeHandler = (e, field) => {
    let value = e.target.value;
    setNotData({ ...noteData, [field]: value });
    if (field === "note_heading") {
      setNoteError(((prevErr) => ({
        ...prevErr,
        note_heading: ""
      })));
    } else {
      setNoteError(((prevErr) => ({
        ...prevErr,
        note: ""
      })));
    }
  };

  const handleFileChange = (files) => {
    setAttachment({ files });
    setNoteError(((prevErr) => ({
      ...prevErr,
      note_attach: ""
    })));
  };

  const handleFileRemove = (files) => {
    setAttachment({ files });
    setNoteError(((prevErr) => ({
      ...prevErr,
      note_attach: ""
    })));
  };

  const handleRemoveExistingFile = (item) => {
    setRemovedAttachments([...removedAttachments, item.id]);
    setExistingFiles(existingFiles.filter(f => f.id !== item.id));
  };

  const calculateTotalAttachmentSize = () => {
    let totalSize = 0;
    attachment.files.forEach((item) => {
      if (item.size) {
        totalSize += item?.size;
      }
    });
    return totalSize;
  };

  const setFormError = (field, message) => {
    setNoteError((prevFormErrors) => ({
      ...prevFormErrors,
      [field]: message,
    }));
  };

  const submithandler = (e) => {
    e.preventDefault();
    const headValidation = Validations({
      value: noteData?.note_heading,
      Validations: { required: true },
    });
    const contentValidation = Validations({
      value: noteData?.note,
      Validations: { required: true },
    });
    if (!headValidation.valid) {
      setFormError("note_heading", headValidation.error_msg);
    }
    if (!contentValidation.valid) {
      setFormError("note", contentValidation.error_msg);
    }
    const totalSize = calculateTotalAttachmentSize();
    if (totalSize > 25 * 1024 * 1024) {
      setFormError("note_attach", "Total attachment size cannot exceed 25MB");
      return;
    }
    if (headValidation?.valid === true && contentValidation?.valid) {
      const payload = {
        note_id: props.noteSpecific.note_id,
        ...noteData,
        note_attach: attachment,
        removed_attachments: JSON.stringify(removedAttachments),
        individual_id: workerRedirectSpecificData?.individual_id ? workerRedirectSpecificData?.individual_id : "",
      };
      props?.setButtonDisabled(true);
      dispatch(UpdateWorkerNote(payload)).then((response) => {
        if (response.success === true) {
          props?.setButtonDisabled(false);
          setDialogAddOpen(true);
          clearFormErrors();
        } else if (response.status === 401) {
          handleUnauthorizedAccess();
        }
      }).catch((error) => {
        console.error("error", error);
      }).finally(() => {
        props?.setButtonDisabled(false);
      });
    }
  };

  return (
    <React.Fragment>
      <form>
        <div className="mt-6 add-client-form px-6 ">
          <div className="flex justify-between mb-5">
            <div className="lavel-wd">
              <label className="text-gray-700 font-medium">Note heading*</label>
            </div>
            <div className="columns-input">
              <input
                type="text"
                className=" input-shadow h-9 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                value={noteData?.note_heading}
                onChange={(e) => inputChangeHandler(e, "note_heading")}
              />
              {noteError?.note_heading && (
                <div className="text-red-500 text-sm ">{noteError?.note_heading}</div>
              )}
            </div>
          </div>

          <div className="flex justify-between mb-5">
            <div className="lavel-wd">
              <label className="text-gray-700 font-medium">Note*</label>
            </div>
            <div className="columns-input">
              <textarea
                placeholder="Enter a note..."
                className="min-h06  resize-none input-shadow text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                value={noteData?.note}
                onChange={(e) => inputChangeHandler(e, "note")}
              ></textarea>
              {noteError?.note && (
                <div className="text-red-500 text-sm ">{noteError?.note}</div>
              )}
            </div>
          </div>

          {existingFiles && existingFiles.length > 0 && (
            <div className="flex justify-between mb-5">
              <div className="lavel-wd">
                <label className="text-gray-700 font-medium">Existing Attachments</label>
              </div>
              <div className="columns-input">
                <div className="flex flex-col gap-2">
                  {existingFiles.map((item, index) => (
                    <div key={index} className="flex justify-between items-center bg-gray-50 border border-gray-200 rounded-lg p-2">
                      <span className="text-xs text-gray-700 truncate max-w-xs">{item.name}</span>
                      <button
                        type="button"
                        onClick={() => handleRemoveExistingFile(item)}
                        className="text-red-500 hover:text-red-700 text-xs font-semibold px-2"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="flex justify-between">
            <div className="lavel-wd">
              <label className="text-gray-700 font-medium">
                Add Attachment (optional)
              </label>
            </div>
            <div className="columns-input">
              <div className="hideIcons wrap-doc">
                <Upload
                  draggable
                  className="border border-gray-200 rounded-xl py-4 px-6 w-full text-center"
                  onChange={handleFileChange}
                  onFileRemove={handleFileRemove}
                  multiple={true}
                  maxFileSize={25 * 1024 * 1024}
                >
                  <span className="text-blue-700 font-semibold">
                    Click to upload
                  </span>{" "}
                  <p className="text-gray-600">(max.25mb)</p>
                </Upload>
                {noteError?.note_attach && (
                  <div className="text-red-500 text-sm ">{noteError?.note_attach}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="flex dailog-footer ">
          <BtnLight disabled={props?.buttonDisabled} onClick={props.onDiaCloseBtn}>Cancel</BtnLight>
          <BtnPrimary disabled={props?.buttonDisabled} type="submit" className="ml-1.5" onClick={submithandler}>
            {props?.buttonDisabled ? <ThreeDotLoader /> : 'Update note'}
          </BtnPrimary>
        </div>
      </form>
      <Dialog
        isOpen={dialogAddOpen}
        onClose={onAddDialogClose}
        onRequestClose={onAddDialogClose}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="49"
              height="49"
              viewBox="0 0 49 49"
              fill="none"
            >
              <rect
                x="0.583008"
                y="1.37207"
                width="47"
                height="47"
                rx="23.5"
                fill="#D1FADF"
              />
              <rect
                x="0.583008"
                y="1.37207"
                width="47"
                height="47"
                rx="23.5"
                stroke="#ECFDF3"
              />
              <path
                d="M32.083 18.8721L21.083 29.8721L16.083 24.8721"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            Notes updated successfully!
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => onAddDialogClose()}>Close</BtnLight>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default EditNote;
